import { useTranslation } from 'react-i18next';

import { Icon, Tag, Tooltip } from '~/components';
import { CopyButton } from '~/components/CopyButton/CopyButton';
import { cn } from '~/lib/cn';

import { Status } from '../api/lib/types';

const STATUS_TO_CLASSES = {
  [Status.success]: 'text-success-default',
  [Status.failed]: 'text-error-default',
  [Status.processing]: 'text-info-default',
  [Status.needs_attention]: 'text-warning-default',
};

const STATUS_TO_I18N = {
  [Status.success]: 'success',
  [Status.failed]: 'failed',
  [Status.processing]: 'processing',
  [Status.needs_attention]: 'needsAttention',
};

interface Props {
  status: Status;
  statusMessage: string;
}

export function StatusInfo({ status, statusMessage }: Props) {
  const { t } = useTranslation('ddex-console', { keyPrefix: 'status' });

  return (
    <div className="flex">
      <Tag size="lg" variant="static">
        <Icon
          type="circle"
          size="md"
          className={cn('rounded-full', STATUS_TO_CLASSES[status])}
        />
        <span>{t(STATUS_TO_I18N[status])}</span>
        {statusMessage.length ? (
          <span className="ml-auto flex items-center gap-2xs">
            <Tooltip
              content={statusMessage}
              side="top"
              delayDuration={0}
              contentClassName="mr-xs px-md py-sm text-body-xs"
            >
              <Icon
                type="circle-info"
                variant="light"
                className="text-subtle hover:text-hover"
                size="sm"
              />
            </Tooltip>
            <span onClick={(event) => event.stopPropagation()}>
              <CopyButton
                textToCopy={statusMessage}
                className="size-lg text-subtle hover:text-hover"
              />
            </span>
          </span>
        ) : null}
      </Tag>
    </div>
  );
}

StatusInfo.displayName = 'StatusInfo';
